<template>
	<common-card class-name="omapi-template-preview" :size="3" :class="{ previewing: isOpening || isPreviewing }">
		<img class="omapi-template-preview__image" :src="imgUrl" alt="Template Preview" />
		<div class="omapi-template-preview__actions omapi-card__flex">
			<core-button color="green" class="omapi-template-preview__actions__use" @click.prevent="createCampaign"
				>Use Template</core-button
			>
			<core-loading-button
				class="omapi-template-preview__actions__open"
				color="transparent"
				:is-link="true"
				:href="monsterCampaignUrl"
				:loading="isOpening"
				@click.prevent.stop="preview"
			>
				{{ previewText }}
			</core-loading-button>
		</div>

		<templates-inline-preview-placeholder v-if="isInline" :template="template" />
		<template #footer>
			<div class="omapi-template-preview__title omapi-card__flex">
				<span v-if="template.mobile" class="omapi-template-preview__mobile-badge" title="Mobile Campaign">
					<svg-mobile></svg-mobile>
				</span>
				{{ template.name }}
			</div>
			<templates-featured-badge v-if="isFeatured" />
			<templates-new-badge v-else-if="isNew" />
		</template>
	</common-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { templatePreviewItem } from 'optinmonster-js-library/src/vue/templates/mixins/templatePreviewItem';
const { mapState } = createNamespacedHelpers('templates');

export default {
	mixins: [templatePreviewItem],
	props: {
		template: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		...mapState(['types']),
		typeObject() {
			return this.$get(`types[${this.template.type}]`);
		},
		features() {
			const feature = this.$get('typeObject.feature');
			return feature ? [feature] : [];
		},
		isNew() {
			const created = this.$moment(this.template.created_at, 'YYYY-MM-DD HH:mm:ss');
			const compare = this.$moment().subtract(3, 'month');
			return created.isAfter(compare);
		},
		isFeatured() {
			return this.template.tags.some((tag) => 2 === tag.id);
		},
		userHasAccessToTemplate() {
			return !(
				this.template.premium.length &&
				this.template.premium.some((feature) => !this.$store.getters.hasFeature(feature))
			);
		},
		previewText() {
			return this.$get('$store.state.templates.apiLoaded') ? 'Preview' : 'Loading Preview...';
		},
	},
	created() {
		this.addListeners();
	},
	beforeDestroy() {
		this.removeListeners();
	},
	methods: {
		createCampaign() {
			this.useTemplate();

			if (!this.$store.getters.connected) {
				return this.$modal.show('not-connected');
			}

			return this.userHasAccessToTemplate
				? this.$modal.show('create-campaign-modal')
				: this.$modal.show('no-access');
		},
	},
};
</script>
